import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

const loader = lazyForPaint(
    () => {
        return import(/* webpackChunkName: "request-create-form" */ /* webpackPrefetch: true */ './hocs');
    },
    {
        ssr: true,
    }
);

export const RequestCreatePage = withAsync({
    loader,
});
